<template>

   <div class="container">
                <div class="page-header">
                    <div class="page-title">

                        <div class="crumbs">
                            <ul id="breadcrumbs" class="breadcrumb">
                                 <li>
                                  <router-link :title="'الرئيسيه'" :to="{name: 'dashboard'}"> <i class="flaticon-home-fill"></i> الرئيسيه</router-link>
                                </li>
                                <li>
                                  <router-link :title="'درجات النشاط'" :to="{name: 'activeDegrees'}">درجات النشاط</router-link>
                                </li>
                                 <li class="active">
                                  <router-link :title="'إضافة جديد'" :to="{name: 'activeDegrees.create'}">إضافة جديد</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>


                <div class="row">

                    <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-12  layout-spacing">
                        <div class="statbox widget box box-shadow">
                            <div class="widget-header">
                                <div class="row">
                                    <div class="col-xl-12 col-md-12 col-sm-12 col-12">
                                        <h4>
                                           <i class="flaticon-computer-4"></i>
                                          بيانات درجات النشاط</h4>
                                    </div>
                                </div>
                            </div>
                            <div class="widget-content widget-content-area">
                                <form @submit.prevent="store()">
                                    <div class="row">
                                      <div class="col-md-4">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">المرحلة الدراسية</label>
                                            <treeselect :options="stages" v-model="data.form.stage_id" @select="getGroups" :multiple="false" />
                                            <div class="invalid-feedback" :style="getErrors['stage_id'] ? 'display: block' : 'display: none;'"  v-if="getErrors['stage_id']">
                                                  {{ getErrors['stage_id'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                      <div class="col-md-4">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">الصف الدراسى</label>
                                           
                                            <treeselect :options="groups" v-model="data.form.group_id" @select="getLessons" :multiple="false" />

                                            <div class="invalid-feedback" :style="getErrors['group_id'] ? 'display: block' : 'display: none;'"  v-if="getErrors['group_id']">
                                                  {{ getErrors['group_id'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                      <div class="col-md-4">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">الحلقة</label>
                                            <treeselect :options="lessons" :auto-load-root-options="true" v-model="data.form.lesson_id" @select="getTeachers" :multiple="false"/>
                                            <div class="invalid-feedback" :style="getErrors['lesson_id'] ? 'display: block' : 'display: none;'"   v-if="getErrors['lesson_id']">
                                                  {{ getErrors['lesson_id'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                      <div class="col-md-6" v-if="user.role == 'admin'">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">المعلم</label>
                                            <treeselect :options="teachers" :auto-load-root-options="true" v-model="data.form.teacher_id" :multiple="false"/>
                                            <div class="invalid-feedback" :style="getErrors['teacher_id'] ? 'display: block' : 'display: none;'"   v-if="getErrors['teacher_id']">
                                                  {{ getErrors['teacher_id'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                       <div :class="'col-md-' + (user.role == 'admin' ? '12' : '6')">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">التاريخ</label>
                                            <date-picker v-model="data.form.date_and_time" :editable="true" :calendar="'hijri'"></date-picker>
                                            <div class="invalid-feedback" :style="getErrors['date_and_time'] ? 'display: block' : 'display: none;'"  v-if="getErrors['date_and_time']">
                                                  {{ getErrors['date_and_time'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                      <div class="col-md-12 table-responsive">
                                        <!-- <a href="#" @click.prevent="addStudent" class="rewrite-btn btn-creative btn-3 btn-3a flaticon-plus">إضافة طالب</a> -->

                                        <table class="table table-bordered">
                                          <thead>
                                            <tr class="text-center">
                                            <tr>

                                              <th>الطالب</th>
                                              <th>درجة الطالب</th>
                                              <th>الملاحظات</th>
                                              <!-- <th>#</th> -->
                                            </tr>
                                          </thead>

                                          <tbody>
                                            <tr v-for="(st, k) in data.form.students" :key="k">

                                              <td v-if="data.form.students[k]" style="width:40%">
                                                <p>{{data.form.students[k].student_name}}</p>
                                                <div class="invalid-feedback" :style="getErrors['students.'+k+'.student_id'] ? 'display: block' : 'display: none;'"   v-if="getErrors['students.'+k+'.student_id']">
                                                      {{ getErrors['students.'+k+'.student_id'][0] }}
                                                </div>
                                              </td>
                                              <td>
                                                 <input type="text" v-model="data.form.students[k].student_degree" class="form-control" @change="clcDegree(k)">
                                                <div class="invalid-feedback" :style="getErrors['students.'+k+'.student_degree'] ? 'display: block' : 'display: none;'"   v-if="getErrors['students.'+k+'.student_degree']">
                                                      {{ getErrors['students.'+k+'.student_degree'][0] }}
                                                </div>
                                              </td>
                                              <td>
                                                 <input type="text" v-model="data.form.students[k].notes" class="form-control">
                                                <div class="invalid-feedback" :style="getErrors['students.'+k+'.notes'] ? 'display: block' : 'display: none;'"   v-if="getErrors['students.'+k+'.notes']">
                                                      {{ getErrors['students.'+k+'.notes'][0] }}
                                                </div>
                                              </td>
                                               <!-- <td>
                                                <a href="#" class="btn btn-danger" v-if="k != 0" @click.prevent="deleteFromStudent(st)">x</a>
                                              </td> -->
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>



                                    <button type="submit" class="save-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p"><span>حفظ</span></button>
                                    <button type="button" @click.prevent="resetForm" class="rewrite-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p"><span>تفريغ</span></button>
                                    <router-link class="back-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p" :to="{name: 'activeDegrees'}">
                                      <span>رجوع</span>
                                    </router-link>


                                    </form>
                            </div>
                        </div>
                    </div>

                </div>

            </div>

</template>
<script>
import router from '@/router'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import VueDatetimeJs from 'vue-datetime-js'

export default {
  components: {
    Treeselect,
    datePicker: VueDatetimeJs,

  },
  data() {
    return {
      trans: {},
      data: {
        checkerExit: 0,
        form: {
          teacher_id: '',
          lesson_id: '',
          group_id: '',
          stage_id: '',
          date_and_time: '',
          students: [
            {
            notes: '',
            student_id: '',
            student: '',
            student_degree: '0',
            date_and_time: '',
            stOptions: []
            }
          ],
        },
        permissions: [],
        isRequested: false,
        errors: {},
        paginated: {},
        allSelected: false,
      },
      lessons: [],
      stages: [],
      groups: [],
      teachers: [],
    };
  },
  created() {
    this.getRequirement();
  },
  methods: {
    resetForm(){
      this.data.form.teacher_id = '';
      this.data.form.lesson_id = '';
      this.data.form.group_id = '';
      this.data.form.stage_id = '';
      this.data.form.date_and_time = '';

      for (let index = 0; index < this.data.form.students.length; index++) {
        this.data.form.students[index].student_id = '';
        this.data.form.students[index].notes = '';
        this.data.form.students[index].student = '';
        this.data.form.students[index].student_name = '';
        this.data.form.students[index].student_degree = '5';
        this.data.form.students[index].date_and_time = '';

      }
    },
    store(){
      this.data.isRequested = true;
      this.$baseApi.post('/activeDegrees', this.data.form).then((response) => {
        if (response.data.code === 200) {
          localStorage.setItem('flash_message', response.data.messages[0]);
          this.sweetAlert(response.data.messages[0]);
          router.push('/activeDegrees');
        }
      }).catch((error) => {
        this.data.errors = JSON.parse(JSON.stringify(error.response.data.errors));
        this.data.isRequested = false
      })
    },
    deleteFromStudent(data){
      this.data.form.students.splice(this.data.form.students.indexOf(data), 1);
    },
    addStudent(){
      this.data.form.students.push({
          student_id: '',
          student: '',
          notes: '',
          student_degree: '5',
          date_and_time: this.data.form.date_and_time,
          stOptions: []
      })
    },
    clcDegree(k){
      let degree = this.data.form.students[k].student_degree;
      this.data.form.students[k].student_degree = degree > 5 ? '5' : (degree < 0 ? '0' : degree);
    },
    
      getGroups(val){
         this.$baseApi.get('/activeDegrees/create?option=group&i='+val.id).then((response)=>{
            if(response.data.code == 200){
               this.groups = response.data.data.groups;
            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },

      getLessons(val){
         this.$baseApi.get('/activeDegrees/create?option=lesson&i='+val.id).then((response)=>{
            if(response.data.code == 200){
               this.lessons = response.data.data.lessons;
            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },
      getStudents(){
         this.$baseApi.get('/activeDegrees/create?option=student&d='+ this.data.form.date_and_time + '&i=' + this.data.form.lesson_id).then((response)=>{
            if(response.data.code == 200){
               this.data.form.students = response.data.data.students;
            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },
    getTeachers(val){
      this.data.form.teacher_id = '';
      if(this.user.role == 'teacher'){
        this.data.form.teacher_id = this.user.teacher_id;
        return;
      }
       this.$baseApi.get('/activeDegrees/create?l=' + val.id).then((response)=>{
            if(response.data.code == 200){
               this.teachers = response.data.data.teachers;

            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
    },
    getRequirement(){
          this.$baseApi.get('/activeDegrees/create?basic_pluck=1').then((response)=>{
            if(response.data.code == 200){
               this.lessons  = response.data.data.lessons;
               this.groups  = response.data.data.groups;
               this.stages  = response.data.data.stages;
               this.teachers = response.data.data.teachers;
               if(this.user.role == 'teacher'){
                this.data.form.teacher_id = this.user.teacher_id;
              }

            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },


      setNewStVal($event, k){
        for (let index = 0; index < this.data.form.students.length; index++) {
              if($event.id == this.data.form.students[index].student_id){
                this.sweetAlert('لا يمكنك اختيار طالب اكثر من مرة', 'warning');
                this.data.form.students[k].student_id = null;
                this.data.form.students[k].student    = null;
                return;
              }
          }
           this.data.form.students[k].student_id = $event && $event.id ? $event.id : '';
           this.data.form.students[k].student = $event && $event.id ? $event.label : '';
        },

  loadOptions(search, key) {
    if(this.data.form.lesson_id == ''){
      this.sweetAlert('لا يمكنك اختيار طالب قبل اختيار الحلقة', 'warning');
      return;
    }
    if(search == ''){
      this.data.form.students[key].stOptions = [];
      return;
    }
      this.$baseApi.get('/activeDegrees/create?student=' + search + '&lesson=' + this.data.form.lesson_id).then((response)=>{
            if(response.data.code == 200){

               this.data.form.students[key].stOptions  = response.data.data.options;

            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
  }

  },
  computed: {
    getErrors() {
      return JSON.parse(JSON.stringify(this.data.errors))
    },
    user(){
      return this.$store.getters.SET_AUTH_USER;
    }
  },
  watch:{
     'data.form.date_and_time': function (newVal, oldVal){
         this.getStudents();
     }
 }
};
</script>
<style>
.role-box {
  border-radius: 6px;
  box-shadow: 1px 1px 4px 0 #0000004a;
  padding: 11px;
}

.role-box h5 {
  text-align: center;
  border-bottom: 1px solid #8080808c;
}

.role-selected {
  border-radius: 6px;
  box-shadow: 0 2px 2px 0 #00000042;
  margin-left: 0 !important;
  margin-right: 0 !important;
  padding: 11px;
}
</style>
